import { render, staticRenderFns } from "./availability-toggle.vue?vue&type=template&id=b55954a0&scoped=true&"
import script from "./availability-toggle.vue?vue&type=script&lang=js&"
export * from "./availability-toggle.vue?vue&type=script&lang=js&"
import style0 from "./availability-toggle.vue?vue&type=style&index=0&id=b55954a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55954a0",
  null
  
)

export default component.exports